<template>
    <Fragment>
        <div class="page-container saved-outfits-container">
            <transition name="fade">
                <div v-if="!savedOutfits || savedOutfitsDataLoading"
                    :key="1"
                    class="loading-overlay">
                    <loader></loader>
                </div>
                <div v-else key="2" style="padding-bottom: 50px;">
                    <div v-if="savedOutfits.length < 1">
                        <div class="no-results-message">
                            You currently don't have any saved items {{ savedOutfitsCount > 0 ? 'with those filters' : '' }}
                        </div>
                    </div>

                    <div class="saved-items-container" v-else>
                        <div class="saved-outfit-container"
                            v-for="outfit in savedOutfits"
                            :key="outfit.outfit_id"
                        >
                            <div class="outfit-header">
                                <span class="count">{{ outfit.products.length }} items</span>
                                <a class="remove" @click="() => openUnsaveModal(outfit)">Remove</a>
                            </div>
                            <div class="grid-items">
                                <div class="grid-items-wrapper">
                                    <div v-for="product in outfit.products"
                                        class="grid-item"
                                        @click.stop="() => handleItemImageClick(product, outfit)"
                                        :style="{ backgroundImage: `url('${decodeURI(product.product_image_url)}')` }"
                                        :key="`${product.product_id}_${product.product_option_value_id}`"
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <infinite-loading
                            @infinite="getMoreOutfits"
                            spinner="waveDots"
                            ref="infiniteLoading"
                        >
                            <div slot="no-more">No more outfits to show!</div>
                            <div slot="no-results"></div>
                        </infinite-loading>
                    </div>
                </div>
            </transition>
        </div>
        <unsave-item-modal v-if="unsaveModalOpened" itemType="outfit" :confirm="unsaveOutfit" :close="closeUnsaveModal" :loading="unsaveLoading" />
    </Fragment>
</template>

<script>
    import $ from 'webpack-zepto'
    import {mapGetters} from 'vuex';
    import { Fragment } from 'vue-fragment';
    import Mixins from '../../mixins/mixins';
    import Loader from '../common/loader.vue';
    import UnsaveItemModal from './unsave-item-modal.vue';
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        data() {
            return {
                pageNumber: 1,
                dataLoading: true,
                outfitToUnsave: null,
                unsaveModalOpened: false,
                unsaveLoading: false,
                page: 1,
            }
        },
        mixins: [Mixins],
        components: {
            Loader,
            UnsaveItemModal,
            InfiniteLoading,
            Fragment,
        },
        computed: {
            ...mapGetters({
                savedOutfits: 'savedOutfits/savedOutfits',
                savedOutfitsDataLoading: 'savedOutfits/savedOutfitsDataLoading',
                savedOutfitsCount: 'savedOutfits/savedOutfitsCount',
            }),
        },
        methods: {
            setSavedOutfit(outfit) {
                this.$store.commit('savedOutfits/setCurrentOutfit', outfit);
                this.$router.push({path: '/saved-outfits/outfit'});
            },
            setSavedOutfits(outfits) {
                this.$store.commit('savedOutfits/setSavedOutfits', outfits);
            },
            unsaveOutfit() {
                this.unsaveLoading = true;
                this.$store.dispatch('savedOutfits/scoreOutfit', {
                    outfit: this.outfitToUnsave,
                    score: -1
                }).finally(this.closeUnsaveModal);
            },
            openUnsaveModal(outfit) {
                this.unsaveModalOpened = true;
                this.outfitToUnsave = outfit;
            },
            closeUnsaveModal() {
                this.unsaveModalOpened = false;
                this.outfitToUnsave = null;
                this.unsaveLoading = false;
            },
            getMoreOutfits($state) {
                this.$store.dispatch('savedOutfits/fetchSavedOutfits', { soft: false, page: this.page })
                    .then(function (outfits) {
                        if(outfits.length === 0){
                            $state.complete();
                        } else {
                            this.page++;
                            $state.loaded();
                        }
                    }.bind(this)).catch(() => {
                        $state.error();
                    });
            },
            handleItemImageClick(product, outfit) {
                this.$store.commit('savedOutfits/setCurrentOutfit', outfit);
                this.$store.commit(
                    'menu/setReturnPage',
                    {
                        href: '/saved-outfits',
                        title: 'Back to Saved Outfits'
                    }
                );
                this.$helpers.visitProduct(
                    this.$router,
                    product,
                    {
                        outfitId: outfit.outfit_id,
                        outfitType: outfit.type,
                    }
                );
            }
        },
        created() {
            this.$store.commit('savedOutfits/setSavedOutfitsLoading', true);
            this.$store.dispatch('savedOutfits/fetchSavedOutfits', { soft: false })
                .catch(error => {
                        console.log('error loading saved outfits:', error);
                        this.dataLoading = false;
                }).finally(() => {
                    this.$helpers.scrollToLastSavedPosition(this.$router.currentRoute.path);
                });
        },
    }
</script>